import { render } from "./stackholder-delete-modal.vue?vue&type=template&id=c0fc2516"
import script from "./stackholder-delete-modal.vue?vue&type=script&lang=js"
export * from "./stackholder-delete-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__